import React from "react";
import { Satellite, SatelliteDish, Tv } from "lucide-react";

const GOLD = "#FFC93C";
const pct = (p, size) => ({ left: `${(p[0] / size[0]) * 100}%`, top: `${(p[1] / size[1]) * 100}%` });

const Marker = ({ p, size, Icon, id, big }) => (
  <span className={`pointer-events-none absolute z-10 grid place-items-center rounded-full border-2 border-white shadow-[0_4px_16px_rgba(255,201,60,0.6)] ${big ? "-ml-3 -mt-3 h-6 w-6 sm:-ml-4 sm:-mt-4 sm:h-8 sm:w-8" : "-ml-2.5 -mt-2.5 h-5 w-5 sm:-ml-3.5 sm:-mt-3.5 sm:h-7 sm:w-7"}`} style={{ ...pct(p, size), background: GOLD }} data-testid={`villa-sat-${id}`}>
    <Icon size={big ? 15 : 13} color="#090A0C" strokeWidth={2.4} />
  </span>
);

export const SatOverlay = ({ sat, size, reduce }) => {
  const [dx, dy] = sat.dish;
  return (
    <>
      <svg className="pointer-events-none absolute inset-0 h-full w-full" viewBox={`0 0 ${size[0]} ${size[1]}`} preserveAspectRatio="none" aria-hidden="true" data-testid="villa-sat-paths">
        <line x1={sat.sky[0]} y1={sat.sky[1]} x2={dx} y2={dy} stroke={GOLD} strokeOpacity="0.35" strokeWidth="10" strokeLinecap="round" />
        <line x1={sat.sky[0]} y1={sat.sky[1]} x2={dx} y2={dy} stroke={GOLD} strokeWidth="3" strokeDasharray="4 16" strokeLinecap="round" className={reduce ? "" : "pt-flow"} />
        {sat.tvs.map((t) => {
          const d = `M${dx},${dy} Q${t.c[0]},${t.c[1]} ${t.p[0]},${t.p[1]}`;
          return (
            <g key={t.id}>
              <path d={d} fill="none" stroke={GOLD} strokeOpacity="0.3" strokeWidth="7" strokeLinecap="round" />
              <path d={d} fill="none" stroke="#FFF4D1" strokeWidth="2.5" strokeDasharray="10 14" strokeLinecap="round" className={reduce ? "" : "pt-flow"} />
            </g>
          );
        })}
      </svg>
      <Marker p={sat.sky} size={size} Icon={Satellite} id="satellite" big />
      <Marker p={sat.dish} size={size} Icon={SatelliteDish} id="dish" big />
      {sat.tvs.map((t) => <Marker key={t.id} p={t.p} size={size} Icon={Tv} id={`tv-${t.id}`} />)}
    </>
  );
};
